export const KeyMap = {
  throttle: ['KeyW', 'ArrowUp'],
  brake: ['KeyS', 'ArrowDown'],
  left: ['KeyA', 'ArrowLeft'],
  right: ['KeyD', 'ArrowRight'],
  handbrake: ['Space'],
  nitro: ['ShiftLeft', 'ShiftRight', 'KeyN'],  // NOS Boost
  reset: ['KeyR'],
  garageToggle: ['KeyG'],
  raceStart: ['KeyT'],
  openWorld: ['KeyO'],       // Toggle Open World Modus
  weatherCycle: ['KeyY'],    // Wetter wechseln
  timeCycle: ['KeyU'],       // Tageszeit wechseln
  teleport: ['KeyP'],        // Teleport zur nächsten Stadt
  debugColliders: ['KeyV'],  // Toggle Collider-Visualisierung (Debug)
  car1: ['Digit1'],
  car2: ['Digit2'],
  car3: ['Digit3'],
  car4: ['Digit4'],
  car5: ['Digit5'],
  car6: ['Digit6'],
  car7: ['Digit7']
} as const;
